import type { SplitButtonDesignTokens } from '@primeuix/themes/types/splitbutton'

export default {
    root: {
        borderRadius: '{form.field.border.radius}',
        raisedShadow:
            '0 3px 1px -2px rgba(0, 0, 0, 0.2),0 2px 2px 0 rgba(0, 0, 0, 0.14),0 1px 5px 0 rgba(0, 0, 0, 0.12)',
        roundedBorderRadius: '2rem',
    },
} satisfies SplitButtonDesignTokens
